import React from 'react';
import MathJax from 'react-mathjax-preview';
import kpis from 'utils/kpis';

export class EquationCellRenderer extends React.PureComponent {
  render() {
    const { node } = this.props;

    return (
      <div>
        {node.data.equation && (
          <MathJax math={kpis.formatToAsciiMath(node.data.equation)} />
        )}
      </div>
    );
  }
}
